import React, { useCallback, useEffect, useRef, useState } from "react";
// import notify from "../assets/audio/notify.mp3";
// import components
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Overlay from "./Overlay";
import DCard from "./DCard";
// import { useQuery } from "react-query";
// import orderServices from "../services/orders";
// import { useDispatch, useSelector } from "react-redux";
// import { setProgressOrders } from "../redux/slicers/config";

// const audio = new Audio(notify);
const Header = () => {
  const navRef = useRef(); // ref for navbar
  const [navHeight, setNavHeight] = useState(116); // default height of navbar
  const [toggleMenu, setToggleMenu] = useState(false); // open/hide sidebar in mobile screen
  // const { progressOrder } = useSelector(state => state.config);
  // const dispatch = useDispatch();
  // useQuery(
  //     "getProgressOrders",
  //     () => {
  //         return orderServices.getProgressOrders().then(res => {
  //             if (res.data.data.length > progressOrder.data.length) {
  //                 const promise = audio.play();
  //                 if (promise !== undefined) {
  //                     promise
  //                         .then(_ => {
  //                             // Autoplay started!
  //                         })
  //                         .catch(error => {
  //                             // Autoplay was prevented.
  //                             // Show a "Play" button so that user can start playback.
  //                         });
  //                 }

  //                 // setTimeout(() => {
  //                 //     audioRef.current.pause();
  //                 // }, 2000);
  //             }
  //             console.log(res.data.data);
  //             dispatch(setProgressOrders(res.data.data));
  //         });
  //     },
  //     {
  //         staleTime: 0,
  //         cacheTime: 0,
  //         refetchInterval: 5000,
  //         refetchIntervalInBackground: 5000,
  //     }
  // );
  // shiw / hide sidebar handler
  const toggleMenuHandler = useCallback(() => {
    setToggleMenu(!toggleMenu);
  }, [toggleMenu]);

  useEffect(() => {
    // set new height of navbar
    if (navRef.current) {
      setNavHeight(navRef.current.clientHeight);
    }
  }, []);
  return (
    <div className="fixed w-full z-50">
        <Overlay setToggleMenu={toggleMenuHandler} show={toggleMenu} />
        <DCard className="p-[0_!important] relative z-[50] ">
          <Navbar sidebarHandler={toggleMenuHandler} ref={navRef} />
          <Sidebar showSidebar={toggleMenu} navHeight={navHeight} />
        </DCard>
    </div>
  );
};

export default Header;
